import { ThunkAction } from 'redux-thunk';

import { AppThunkDispatch, AppThunkGetState, IAppStateContainer } from '@Reducers/index';

import { ExpenseTagBucketsApi } from '@ClientApi/expenseTagBucketsApi';
import { FormFieldsApi } from '@ClientApi/formFields';
import { IExpenseTagBucketModel } from '@Shared/models';

import { AddCategoriesForUser, SetCategoriesLoading } from './categoriesActions';

export const ADD_EXPENSE_BUCKETS_WITH_TAGS = 'ADD_EXPENSE_BUCKETS_WITH_TAGS';
export const SET_EXPENSE_BUCKET_WITH_TAGS_LOADING = 'SET_EXPENSE_BUCKET_WITH_TAGS_LOADING';
export const SET_EXPENSE_BUCKET_WITH_TAGS_BY_ID_LOADING = 'SET_EXPENSE_BUCKET_WITH_TAGS_BY_ID_LOADING';
export const EXPENSE_BUCKETS_ADD_EXPENSE_BUCKETS_FOR_USER = 'EXPENSE_BUCKETS_ADD_EXPENSE_BUCKETS_FOR_USER';
export const ADD_EXPENSE_BUCKETS_WITH_TAGS_BY_ID = 'ADD_EXPENSE_BUCKETS_WITH_TAGS_BY_ID';

// (should be not used and removed once we will switch to use paginated API)
export class AddExpenseBucketsWithTags {
  readonly type = ADD_EXPENSE_BUCKETS_WITH_TAGS;

  constructor(public payload: IExpenseTagBucketModel[]) {}
}

export class SetExpenseBucketWithTagsLoading {
  readonly type = SET_EXPENSE_BUCKET_WITH_TAGS_LOADING;

  constructor(public payload: boolean) {}
}

export class SetExpenseBucketWithTagsByIdLoading {
  readonly type = SET_EXPENSE_BUCKET_WITH_TAGS_BY_ID_LOADING;

  constructor(public payload: boolean) {}
}

export class AddExpenseBucketsForUser {
  readonly type = EXPENSE_BUCKETS_ADD_EXPENSE_BUCKETS_FOR_USER;
  payload: {
    userId: string;
    expenseBuckets: IExpenseTagBucketModel[];
  };

  constructor(userId: string, expenseBuckets: IExpenseTagBucketModel[]) {
    this.payload = { userId, expenseBuckets };
  }
}

export class AddExpenseBucketsWithTagsById {
  readonly type = ADD_EXPENSE_BUCKETS_WITH_TAGS_BY_ID;

  constructor(public payload: IExpenseTagBucketModel[]) {}
}

export const getExpenseBucketsForUser =
  (userId: string, selectedTagIds: string[] = []) =>
  async (dispatch: AppThunkDispatch) => {
    dispatch(new SetExpenseBucketWithTagsLoading(true));
    dispatch(new SetCategoriesLoading(true));
    const { expenseTagBuckets, categories } = await FormFieldsApi.getSelectableBucketsAndCategories(selectedTagIds, userId);
    dispatch(new AddExpenseBucketsForUser(userId, expenseTagBuckets));
    dispatch(new AddCategoriesForUser(userId, categories));
    dispatch(new SetExpenseBucketWithTagsLoading(false));
    dispatch(new SetCategoriesLoading(false));
  };

export const getExpenseTagBuckets =
  (forceReload = false): ThunkAction<void, IAppStateContainer, unknown, SetExpenseBucketWithTagsLoading | AddExpenseBucketsWithTags> =>
  async (dispatch: AppThunkDispatch, getState: AppThunkGetState) => {
    if (!forceReload) {
      const { expenseBucketsWithTagsLoading, dropdownExpenseBucketsWithTags } = getState().expenseBucketsWithTags;
      if (expenseBucketsWithTagsLoading || dropdownExpenseBucketsWithTags.length) {
        return;
      }
    }
    dispatch(new SetExpenseBucketWithTagsLoading(true));
    const expenseTagBuckets = await ExpenseTagBucketsApi.getExpenseTagBucketsWithTags();
    dispatch(new AddExpenseBucketsWithTags(expenseTagBuckets));
    dispatch(new SetExpenseBucketWithTagsLoading(false));
  };

export const getExpenseBucketsWithTagsById =
  (
    params: {
      includeTeamTags?: boolean;
      includeSalesforceFilters?: boolean;
      includeExpenseTags?: boolean;
    } = {
      includeTeamTags: false,
      includeSalesforceFilters: false,
      includeExpenseTags: false
    },
    forceReload = false
  ) =>
  async (dispatch: AppThunkDispatch, getState: AppThunkGetState) => {
    if (!forceReload) {
      const { expenseBucketsWithTagsByIdLoading, expenseTagBucketsById } = getState().expenseBucketsWithTags;
      if (expenseBucketsWithTagsByIdLoading || expenseTagBucketsById) {
        return;
      }
    }
    dispatch(new SetExpenseBucketWithTagsByIdLoading(true));
    const expenseTagBuckets = await ExpenseTagBucketsApi.getExpenseTagBuckets(
      params.includeTeamTags,
      params.includeSalesforceFilters,
      params.includeExpenseTags
    );
    dispatch(new AddExpenseBucketsWithTagsById(expenseTagBuckets));
    dispatch(new SetExpenseBucketWithTagsByIdLoading(false));
  };

export type ExpenseBucketsWithTagsAction =
  | AddExpenseBucketsWithTags
  | AddExpenseBucketsForUser
  | SetExpenseBucketWithTagsLoading
  | SetExpenseBucketWithTagsByIdLoading
  | AddExpenseBucketsWithTagsById;
